import Link from "next/link";
import { HomeIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

type Breadcrumb = {
  title: string | undefined;
  slug?: string;
};

export const Breadcrumb = ({
  breadcrumbs,
  isApp = false,
}: {
  breadcrumbs: Breadcrumb[];
  isApp?: boolean;
}) => {
  return (
    <div className={"whitespace-nowrap overflow-scroll"}>
      <ul className={"flex"}>
        <li className={"flex"}>
          <Link
            href={`${isApp ? "/app" : "/"}`}
            className={
              "text-sm md:text-base flex items-center hover:opacity-60 duration-100"
            }
          >
            <HomeIcon className={"w-5 mr-2"} />
            ホーム
          </Link>
          <ChevronRightIcon className={"w-5 mx-3"} />
        </li>
        {breadcrumbs?.map((breadcrumb, index) => (
          <li key={index} className={"flex"}>
            {breadcrumb.slug ? (
              <>
                <Link
                  href={breadcrumb.slug}
                  className={"underline text-sm md:text-base"}
                >
                  {breadcrumb.title}
                </Link>
                <ChevronRightIcon className={"w-5 mx-3"} />
              </>
            ) : (
              <p className={"text-sm md:text-base"}>{breadcrumb.title}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
